import { PlayCircleIcon } from '@langchain/untitled-ui-icons';

import { Breadcrumb, BreadcrumbData } from '@/components/Breadcrumbs';

export function EvaluatorPlaygroundCrumb(props: Partial<BreadcrumbData>) {
  return (
    <Breadcrumb
      icon={<PlayCircleIcon className="h-4 w-4" />}
      name={'Evaluator Playground'}
      {...props}
    />
  );
}
